import GermanyContractType from 'modules/contracts/store/models/GermanyContractType'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class ContractTypes extends PayrollLegalEntityResource<GermanyContractType> {
  get cacheKey(): string {
    return 'germanyContractTypes'
  }

  model() {
    return GermanyContractType
  }
}

export { ContractTypes }
